import { motion } from "framer-motion";
import React, { useState, useMemo } from "react";

import { StyledTextArea } from "@/styles/layout";
import { Body } from "@/styles/typography";
import { getCurrentTheme } from "@/styles/theme";

interface Props {
  name?: string | undefined;
  label: string;
  labelStyle?: any | undefined;
  containerStyle?: any | undefined;
  placeholder?: string | undefined;
  onChange: (...i: any[]) => void;
  autoFocus?: boolean | undefined;
  value?: string | number | undefined;
  error?: string | undefined;
}

const TextArea = ({
  name,
  label,
  containerStyle,
  placeholder,
  onChange,
  value,
  autoFocus,
  error,
}: Props) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [isHover, setIsHover] = useState<boolean>(false);

  const isTouched = useMemo(
    () => (value?.toString() ?? "").length > 0,
    [value]
  );

  const active = useMemo(() => isTouched || isFocus, [isTouched, isFocus]);
  return (
    <motion.div
      animate={{
        x: error ? [0, 5, -5, 0] : 0,
      }}
      transition={{ duration: 0.3 }}
      style={{
        position: "relative",
        width: "100%",
        marginTop: 8,
      }}
    >
      <StyledTextArea
        autoFocus={autoFocus}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onChange={(e: any) => {
          // setInputValue(e.target.value);
          onChange(e.target.value);
        }}
        name={name}
        value={value}
        placeholder={placeholder}
        width="100%"
        minWidth="100%"
        maxWidth="100%"
        borderColor="primary.textHigh"
        borderStyle="solid"
        borderWidth="0.5px"
        borderRadius="4px"
        px="16px"
        fontSize="14px"
        animate={{ paddingTop: active ? "16px" : "24px" }}
        fontWeight="200"
        {...containerStyle}
      />
      {label && (
        <motion.label
          animate={{
            top: active ? "0px" : "24px",
            left: active ? "8px" : "16px",

            fontSize: active ? "14px" : isHover ? "14px" : "14px",
            opacity: active ? 1 : 0.6,
          }}
          style={{
            position: "absolute",
            left: "16px",
            transform: "translateY(-50%)",
            zIndex: 0,
            pointerEvents: "none",
            backgroundColor: getCurrentTheme().colors.primary.bgBase,
          }}
        >
          <Body
            color={error ? "danger.textLow" : "form.textHigh"}
            fontWeight="400"
          >
            {error ?? label}
          </Body>
        </motion.label>
      )}
    </motion.div>
  );
};

export default TextArea;
